import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { ItemLibrary } from "app/infrastructure/model/classes/itemLibrary.class";
import { ProductReportService } from "app/infrastructure/services/productreport.service";
import {
  ProductReport,
  MappingProductReportAttribute,
  MappingProductReportAttributeModel,
} from '../../../../infrastructure/model/classes/productReport.class';

interface FilterItem {
  value: string;
  selected: boolean;
}

interface Filter {
  country: FilterItem[];
  type: FilterItem[];
  insurance: FilterItem[];
}

@Component({
  selector: "app-desktop",
  templateUrl: "./subscribe.productreport.component.html",
  styleUrls: ['./subscribe.productreport.component.css']
})
export class SubscribeProductReportComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  isLoading: Boolean = true;
  selectedProductReport: ProductReport = null;
  selectedProductReportId: string = null;
  organizations: ProductReport[] = [];
  organizationsFiltered: any = {};
  search = "";
  objectKeys = Object.keys;

  @Output() onSelect: EventEmitter<ItemLibrary> = new EventEmitter<ItemLibrary>();

  constructor(
    private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public productReportSrv: ProductReportService
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params["codorganizacion"];
      this.subscriptionCode = params["codsistema"];
      this.channelCode = params["codnegocio"];
      this.productCode = params["codproducto"];

      this.productReportSrv
        .getAllWithContext(this.organizationCode,this.subscriptionCode,  this.channelCode, this.productCode)
        .subscribe(res => {
          this.isLoading = false;
          this.organizations = res;
          this.grouping(res);
        });
    });
  }

  grouping(reportConfigurationList: ProductReport[]): void {
    this.organizationsFiltered = _.groupBy(reportConfigurationList, (productReport) => {
        return productReport.category.description;
    });
  }

  clickEdit() {
    this.router.navigate([".", this.selectedProductReportId], {
      relativeTo: this.aRoute,
    });
  }

  clickImport() {
    this.router.navigate([".", this.selectedProductReportId, "import"], {
      relativeTo: this.aRoute,
    });
  }

  selectLibrary(productReport: ProductReport) {
    this.selectedProductReportId = productReport.id;
    this.selectedProductReport = productReport;
  }


  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find((item) => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }

  reportConfigurationSelected(productReport: ProductReport) {
    this.selectedProductReport = productReport;
  }

  applySearch(value: string) {
    if(value === "")
      this.grouping(this.organizations);
    else
    {
      let filtered = this.organizations.filter(
        org =>
          org.productReportCode.toUpperCase().indexOf(value.toUpperCase()) !== -1
      );
      this.grouping(filtered);
    }
  }

  // getObjectKeys(){
  //   console.log (this.organizationsFiltered);
  //   return Object.keys(this.organizationsFiltered)
  // }

  volver() {
    this.router.navigate(["../"], { relativeTo: this.aRoute });
  }

  subscribe(id: string) {
    const productReportContext = {
      "organizationCode": this.organizationCode,
      "subscriptionCode": this.subscriptionCode,
      "channelCode": this.channelCode,
      "productCode": this.productCode,
      "entityId": [`${id}`]
    };

    this.productReportSrv.productReportSubscription(productReportContext).subscribe(resp => {
      if(resp) this.volver();
    })
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/subscribe/subscribe.productreport.component.ts